import type { ReactElement, SVGProps } from "react";

/**
 * Inline HOAi wordmark — rendered as real SVG markup (not an <img>) so the
 * browser paints it as a live vector element rather than a rasterized/cached
 * bitmap. Traced from the original `public/hoai.svg` export. Fill follows
 * `currentColor`, so wrap with a text-color utility (defaults to
 * `text-foreground` if omitted).
 */
export function HoaiWordmark({
  className,
  ...props
}: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 57 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="HOAi"
      className={className}
      {...props}
    >
      <path
        d="M12.12 12.92H5.136V20H1.968V3.248H5.136V10.112H12.12V3.248H15.288V20H12.12V12.92ZM25.794 20.288C24.69 20.288 23.69 20.104 22.794 19.736C21.898 19.368 21.13 18.816 20.49 18.08C19.866 17.344 19.378 16.44 19.026 15.368C18.674 14.296 18.498 13.048 18.498 11.624C18.498 10.216 18.674 8.976 19.026 7.904C19.378 6.816 19.866 5.904 20.49 5.168C21.13 4.432 21.898 3.88 22.794 3.512C23.69 3.144 24.69 2.96 25.794 2.96C26.898 2.96 27.898 3.144 28.794 3.512C29.69 3.88 30.458 4.432 31.098 5.168C31.738 5.904 32.226 6.816 32.562 7.904C32.914 8.976 33.09 10.216 33.09 11.624C33.09 13.048 32.914 14.296 32.562 15.368C32.226 16.44 31.738 17.344 31.098 18.08C30.458 18.816 29.69 19.368 28.794 19.736C27.898 20.104 26.898 20.288 25.794 20.288ZM25.794 17.48C26.994 17.48 27.946 17.08 28.65 16.28C29.37 15.48 29.73 14.36 29.73 12.92V10.328C29.73 8.888 29.37 7.768 28.65 6.968C27.946 6.168 26.994 5.768 25.794 5.768C24.594 5.768 23.634 6.168 22.914 6.968C22.21 7.768 21.858 8.888 21.858 10.328V12.92C21.858 14.36 22.21 15.48 22.914 16.28C23.634 17.08 24.594 17.48 25.794 17.48ZM46.0391 20L44.6951 15.728H38.7431L37.4231 20H34.2071L39.8231 3.248H43.7591L49.3271 20H46.0391ZM41.7671 6.128H41.6471L39.5111 13.016H43.9271L41.7671 6.128ZM53.1401 5.648C52.5001 5.648 52.0361 5.504 51.7481 5.216C51.4761 4.928 51.3401 4.56 51.3401 4.112V3.632C51.3401 3.184 51.4761 2.816 51.7481 2.528C52.0361 2.24 52.5001 2.096 53.1401 2.096C53.7641 2.096 54.2201 2.24 54.5081 2.528C54.7961 2.816 54.9401 3.184 54.9401 3.632V4.112C54.9401 4.56 54.7961 4.928 54.5081 5.216C54.2201 5.504 53.7641 5.648 53.1401 5.648ZM51.6041 7.472H54.6761V20H51.6041V7.472Z"
        fill="currentColor"
      />
    </svg>
  );
}
